<span style="display: none" #iconnamecontainer>
  <ng-content></ng-content>
</span>
<div [style.height]="size+'px'" [style.width]="size+'px'" [innerHTML]="icon_content|raw" style="max-width: 100%; max-height: 100%" *ngIf="icon_content"></div>
<div style="color: red" [style.height]="size+'px'" [style.width]="size+'px'"
     class="svg-icon" *ngIf="error" >{{error}}</div>
